import { useRef } from 'react';
import type { CreateFeedRequest } from '../repositories/feedRepository';

interface FeedFormProps {
  onSubmit: (feed: CreateFeedRequest) => void;
}

export function FeedForm({ onSubmit }: FeedFormProps) {
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = new FormData(e.currentTarget);
    onSubmit({
      feed_url: form.get('feed_url') as string,
      title: form.get('title') as string,
      description: form.get('description') as string,
    });
    formRef.current?.reset();
  };

  return (
    <section className="admin-panel">
      <h2>Add feed</h2>
      <form ref={formRef} onSubmit={handleSubmit} className="site-form">
        <label>
          <span>Feed URL</span>
          <input type="url" name="feed_url" placeholder="https://example.com/feed.xml" required />
        </label>
        <label>
          <span>Title</span>
          <input type="text" name="title" placeholder="My Favorite Blog" />
        </label>
        <label>
          <span>Description</span>
          <textarea name="description" rows={3} placeholder="What this feed covers..." />
        </label>
        <button type="submit" className="primary-button">Add feed</button>
      </form>
    </section>
  );
}
